import t from "@/lang/lang";
import {
  BaseDataPage,
  BaseDataPageContent,
  BaseDataPageHeader,
  BaseDataPageTitle,
} from "@/routes/base-data/_components/layout/base-data-page";
import { EditLabCard } from "@/services/backend/samples/components/edit-lab-card";
import { DeleteLabDialog } from "@/services/backend/samples/components/delete-lab-dialog";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { Button } from "@/shared/components/ui/button";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";
import { PersistenceStateUsingContext } from "@/shared/lib/persistence-state/persistence-state-info";
import { ArrowLeft } from "lucide-react";
import { NavLink, useNavigate, useParams } from "react-router";
import { useSamplesLaboratoryShowQuery } from "@/services/backend/samples/api/lab-api";

export function LabRoute() {
  const { labId } = useParams();
  const navigate = useNavigate();
  const {
    data: lab,
    isLoading,
    error,
  } = useSamplesLaboratoryShowQuery({ id: labId! });

  return (
    <PersistenceContextProvider>
      <BaseDataPage>
        <BaseDataPageHeader>
          <BaseDataPageTitle>
            {t("Labor")} {lab?.name}
            <div className="flex items-center gap-4">
              <PersistenceStateUsingContext />
              {lab && (
                <DeleteLabDialog lab={lab} onDelete={() => navigate("../")} />
              )}
            </div>
          </BaseDataPageTitle>
        </BaseDataPageHeader>
        <BaseDataPageContent>
          <NavLink to="../">
            <Button variant="outline" className="mb-2">
              <ArrowLeft />
              <span>{t("Zurück zur Übersicht")}</span>
            </Button>
          </NavLink>
          {error && <RTKQueryErrorAlert error={error} />}
          {isLoading && <CardSkeleton />}
          {lab && <EditLabCard lab={lab} key={lab.id} />}
        </BaseDataPageContent>
      </BaseDataPage>
    </PersistenceContextProvider>
  );
}
